import { render, staticRenderFns } from "./dictamenes.vue?vue&type=template&id=e06e4fca"
import script from "./dictamenes.vue?vue&type=script&lang=js"
export * from "./dictamenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports